/**
 * @param {string} teaserLinkTarget - link URL.
 * @param {string} title - link title.
 * @returns {string} link as HTML.
 */
export default (teaserLinkTarget, title) => `
    <div class="teaser-link">
        <a href="${teaserLinkTarget}" title="${title}">
            ${title}
        </a>
    </div>`;
